export default "__VITE_ASSET__D$nRj9FE__"